<template>
    <SlotContainer :data-label="dataLabel">
        <b-row class="gx-0 mb-4">
            <b-col cols="12" class="dd">
                <label class="mb-3" :for="`${dataLabel}-included`"><strong>{{ $translate(`included-${dataLabel}`)
                        }}</strong></label>
                <multiselect v-model="includedData" :id="`${dataLabel}-included`" label="name" track-by="id"
                    :placeholder="$translate(`select-included-${dataLabel}`)" open-direction="bottom"
                    :options="queriedData" :multiple="true" :searchable="true" :loading="isLoading"
                    :internal-search="false" :clear-on-select="false" :close-on-select="false" :show-no-results="false"
                    :hide-selected="true" @search-change="(q) => $emit('async-find', q)">
                    <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="includedData.length"
                            @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oops! No elements found. Consider changing the search
                        query.
                    </span>
                </multiselect>
            </b-col>
        </b-row>
        <b-row class="gx-0 mb-2" v-if="!includeOnly">
            <b-col cols="12" class="dd">
                <label class="mb-3" :for="`${dataLabel}-excluded`"><strong>{{ $translate(`excluded-${dataLabel}`)
                        }}</strong></label>
                <multiselect v-model="excludedData" :id="`${dataLabel}-excluded`" label="name" track-by="id"
                    :placeholder="$translate(`select-excluded-${dataLabel}`)" open-direction="bottom"
                    :options="queriedData" :multiple="true" :searchable="true" :loading="isLoading"
                    :internal-search="false" :clear-on-select="false" :close-on-select="false" :show-no-results="false"
                    :hide-selected="true" @search-change="(q) => $emit('async-find', q)">
                    <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="excludedData.length"
                            @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oops! No elements found. Consider changing the search
                        query.
                    </span>
                </multiselect>
            </b-col>
        </b-row>
    </SlotContainer>
</template>

<script lang="js">
import Multiselect from 'vue-multiselect'
import SlotContainer from './SlotContainer.vue';


export default {
    name: 'includeExcludeAsync',
    components: {
        Multiselect, SlotContainer
    },

    props: {
        modelInclude: {
            type: Array,
            default: () => [],
        },
        modelExclude: {
            type: Array,
            default: () => [],
        },
        queriedData: {
            type: Array,
            default: () => [],
        },
        selectedData: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        includeOnly: {
            type: Boolean,
            default: false
        },
        dataLabel: { type: String, required: true },
    },

    data() {
        return {
            includedData: [],
            excludedData: [],
        }
    },


    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },

        parsedIncludedData() {
            const { selectedData, queriedData, modelInclude } = this;
            return modelInclude.map(id => [...queriedData, ...selectedData].find(y => y.id == id));
        },
        parsedExcludedData() {
            const { selectedData, queriedData, modelExclude, includeOnly } = this;
            return includeOnly ? [] : modelExclude.map(id => [...queriedData, ...selectedData].find(y => y.id == id));
        },
        compositeIds() {
            return [...new Set([...this.modelInclude ?? [], ...this.modelExclude ?? []])];
        }
    },
    watch: {
        compositeIds: {
            handler: function (ids) {
                const dataLessIds = [];
                for (const id of ids) {
                    if (![...this.queriedData, ...this.selectedData].some(x => x.id == id)) {
                        dataLessIds.push(id)
                    }
                }
                if (dataLessIds.length) {
                    this.$emit("get-selected-data", dataLessIds)
                }
            },
            immediate: true,
            deep: true
        },
        parsedIncludedData: {
            handler: function (val, oldVal) {
                this.includedData.length = 0;
                this.includedData.push(...val);
            },
            deep: true,
            immediate: true
        },
        parsedExcludedData: {
            handler: function (val, oldVal) {
                this.excludedData.length = 0;
                this.excludedData.push(...val);
            },
            deep: true,
            immediate: true
        },
        includedData: {
            handler: function (val, oldVal) {
                this.$emit("update:modelInclude", [...val.map(x => x.id)])
            },
            deep: true,
        },
        excludedData: {
            handler: function (val, oldVal) {
                this.$emit("update:modelExclude", [...val.map(x => x.id)])
            },
            deep: true,
        }
    },



    methods: {
        limitText(count) {
            return `and ${count} other items`
        },
        clearAll() {
            this.includedData.length = 0
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>